import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PlaceholderLoading from "react-placeholder-loading";

const CustomerDetailRow = ({ title, isLastItem, children, width, icon, marginBottom, loading }) => (
  <>
    <Row className={`mb-${marginBottom ?? 1}`}>
      {icon ? (
        <Col xs={1} className="mt-1">
          <FontAwesomeIcon className="fa-lg" icon={icon} />
        </Col>
      ) : null}

      <Col className="mb-3 pl-0 pr-0">
        <Col className="mr-0" xs={12} sm={width || 12}>
          <p
            className={classNames("font-weight-semi-bold fs--1 mb-1", {
              "mb-0": isLastItem,
              "mb-1": !isLastItem,
            })}
          >
            {loading ? <PlaceholderLoading shape="rect" width={200} height={15} /> : title}
          </p>
        </Col>
        <Col className="fs--1" xs={12}>
          {loading ? <PlaceholderLoading shape="rect" width={250} height={15} /> : children}
        </Col>
      </Col>
    </Row>
  </>
);
CustomerDetailRow.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isLastItem: PropTypes.bool,
};
CustomerDetailRow.defaultProps = { last: false };

export default CustomerDetailRow;
